<template>
  <div
      class="mail__content"
      v-for="(item, index) in mails"
      :key="`mail_${index}`"
  >
    <v-row
        no-gutters
        class="mail__block"
    >
      <v-col class="mail__block_logo">
        <v-img
            v-if="item.partner.logo"
            alt="placeholder_partner"
            :max-width="$vuetify.display.width >= 1280 ? 170 : 250"
            width="100%"
            :max-height="$vuetify.display.width >= 1280 ? 150 : 100"
            :src="getFileLink(item.partner.logo.link)"
        />
      </v-col>
      <v-col class="mail__block_text">
        {{ item.subject }}
      </v-col>
      <v-col class="mail__block_code">
        <div>
          <div class="mail__block_code--usage">
            {{convertDate(item.date)}}
          </div>
<!--          <div-->
<!--              class="mail__block_code&#45;&#45;number"-->
<!--              @click="!loading ? userTakePromocode(item) : ''"-->
<!--          >-->
<!--            <div-->
<!--                class="mail__block_code&#45;&#45;cover"-->
<!--                v-if="item.cover"-->
<!--            >-->
<!--              <v-img-->
<!--                  alt="mail_cover"-->
<!--                  height="40"-->
<!--                  :src="mail_cover"-->
<!--              />-->
<!--            </div>-->
<!--            <p v-else>{{ item.value }}</p>-->
<!--          </div>-->
          <div>
            <v-btn
                :color="'#376FFE'"
                width="110"
                height="25"
                elevation="0"
                :class="'mail__block_btn'"
                @click.stop="getDetail(item)"
            >
              Подробнее
            </v-btn>
          </div>
          <div
              class="mail__block_code--date"
          >
            {{ item.from.email }}
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import helper from "@/urls/helper"
import names from "@/modules/personal_account/routers/names"
import moment from "moment"

export default defineComponent({
  name: "MailCard",
  props: {
    mails: {
      type: Array,
      default: () => []
    },
    justify_row: {
      type: String,
      default: 'start'
    }
  },
  data () {
    return {
      covers: {}
    }
  },
  methods: {
    getFileLink (url) {
      return helper.getMendeleevUrlWithParameters(url.basename, url.action, url.params, null)
    },
    getDetail (item) {
      this.$router.push({ name: names.MAIL.DETAIL, params: { id: item.id } })
    },
    convertDate (value) {
      return moment(value).format('YYYY-MM-DD HH:MM')
    }
  },
  beforeRouteLeave () {
    if (window.scrollY !== 0) {
      window.scroll({
        top: 0,
        behavior: 'smooth'
      })
    }
  }
})
</script>

<style scoped lang="scss">
.mail__content {
  padding: 50px 50px 0;

  &:last-child {
    padding-bottom: 50px;
  }
}

.mail__block {
  height: 176px;
  box-sizing: border-box;
  border: 1px dashed rgba(49, 55, 67, 1);
  filter: drop-shadow(1px 1px 10px rgba(52, 52, 124, 0.1));
  border-radius: 5px;
}

.mail__block_logo {
  max-width: 21.6%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.mail__block_text {
  max-width: 48.5%;
  padding-inline: 30px 30px !important;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  text-align: left;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #313743;
}

.mail__block_code {
  max-width: 29.9%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-left: 1px dashed rgba(49, 55, 67, 1);

  &--usage {
    height: 20px;
    margin-bottom: 10px;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 15px;
    text-align: center;
    color: #3254B9;
  }

  &--number {
    margin: 20px 0;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 212px;
    height: 40px;
    background-color: #ECEFFB;
    border-radius: 5px;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: #313743;
  }

  &--cover {
    position: absolute;
    left: 0;
    bottom: 0;
    cursor: pointer;
  }

  &--date {
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 20px;
    margin-top: 10px;
    height: 20px;
    text-align: center;
    color: #959595;
  }
}

.mail__block_btn {
  border-radius: 25px;
  color: white;
  font-style: normal;
  font-weight: 600;
  text-transform: capitalize;
  font-size: 11px;
  line-height: 15px;

  &.copy {
    color: #376FFE;
    border: 1px solid #376FFE;
  }

  &.annul {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 110px;
    height: 25px;
  }
}

@media screen and (min-width: 961px) and (max-width: 1280px) {
  .mail__block_logo {
    padding-left: 20px !important;
  }
}

@media screen and (max-width: 960px) {
  .mail__content {
    padding: 0 0 50px;

    &:last-child {
      padding-bottom: 0;
    }
  }

  .mail__block {
    height: 371px;
  }

  .mail__block_logo {
    margin-top: 10px;
    margin-bottom: 10px;
    height: 100px;
    width: 100%;
    max-width: 100%;
    min-width: 560px;
  }

  .mail__block_text {
    margin-bottom: 10px;
    width: 100%;
    height: 79px;
    max-width: 100%;
    min-width: 560px;
    padding-inline: 20px 20px !important;

    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
  }

  .mail__block_code {
    width: 100%;
    height: 162px;
    max-width: 100%;
    min-width: 560px;
    border-left: none;
    border-top: 1px dashed rgba(49, 55, 67, 1);
  }
}

@media screen and (max-width: 768px) {
  .mail__content {
    padding: 0 0 20px;

    &:last-child {
      padding-bottom: 0;
    }
  }

  .mail__block_logo {
    min-width: 420px;
  }

  .mail__block_text {
    min-width: 420px;
  }

  .mail__block_code {
    min-width: 420px;
  }
}

@media screen and (max-width: 600px) {
  .mail__block_logo {
    min-width: 330px;
  }

  .mail__block_text {
    min-width: 330px;
  }

  .mail__block_code {
    min-width: 330px;
  }
}

@media screen and (max-width: 428px) {
  .mail__block_logo {
    min-width: 290px;
  }

  .mail__block_text {
    min-width: 290px;
  }

  .mail__block_code {
    min-width: 290px;
  }
}

@media screen and (max-width: 369px) {
  .mail__block_logo {
    min-width: 220px;
    padding: 0 10px !important;
  }

  .mail__block_text {
    min-width: 220px;
  }

  .mail__block_code {
    min-width: 220px;
  }
}
</style>
